  import newscoverFeb2025 from "./cover/coverpageFEB2025.jpg"
  import newscoverJune2025 from "./cover/newscoverJune2025.png"
  import newscoverNov2024 from "./cover/cover.png"
  import newsletterFeb2025 from "./journals/bunnewsfeb2025.pdf"
  import newsletterJune2025 from "./journals/bunnewsJune2025.pdf"
  import newsletterNov2024 from "./journals/Newsletter(NovPublicationVol1-Issue3).pdf"


  export const newsletter = [
    {
        id: 1, 
        img: newscoverFeb2025, 
        fileUrl: newsletterFeb2025
    },
    {
        id: 2, 
        img: newscoverJune2025, 
        fileUrl: newsletterJune2025
    },
    {
        id: 3, 
        img: newscoverNov2024, 
        fileUrl: newsletterNov2024
    },
  ]